import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import { getMe } from "../api/auth";
import { getLang, setLang } from "../store/uiStore";
import "./Login.css";

const API_URL = process.env.REACT_APP_API_URL;

const translations = {
  tj: {
    system: "Низоми ягона",
    systemSubtitle: "Платформаи ягонаи давлатии рақамикунонии тандурустӣ",
    service: "Хадамоти назорати давлатии тандурустӣ ва ҳифзи иҷтимоии аҳолӣ",
    loginTitle: "Воридшавӣ ба низом",
    loginSubtitle: "Барои идомаи кор маълумоти воридшавии худро ворид намоед",
    username: "Логин",
    usernamePlaceholder: "Логини худро ворид кунед",
    password: "Рамз",
    passwordPlaceholder: "Рамзи худро ворид кунед",
    showPassword: "Намоиши рамз",
    hidePassword: "Пинҳон кардани рамз",
    forgotPassword: "Рамзро фаромӯш кардед?",
    login: "Ворид шудан",
    loggingIn: "Воридшавӣ...",
    otpTitle: "Тасдиқи воридшавӣ",
    otpText: "Рамзи тасдиқ ба почтаи электронии ба ҳисоби шумо вобасташуда фиристода шуд.",
    otpPlaceholder: "Рамзи 6-рақамаро ворид кунед",
    verify: "Тасдиқ кардан",
    verifying: "Тасдиқ...",
    resend: "Аз нав фиристодани рамз",
    resendIn: "Аз нав фиристодан баъд аз",
    seconds: "с",
    back: "Бозгашт",
    resetTitle: "Барқарорсозии рамз",
    resetSubtitle: "Логини худро ворид кунед. Мо рамзи барқарорсозиро ба почтаи электронии вобаста ба ҳисоб мефиристем.",
    sendCode: "Гирифтани рамз",
    sending: "Фиристода истодаем...",
    resetOtpTitle: "Рамзи барқарорсозӣ",
    resetOtpText: "Рамзи барқарорсозӣ ба почтаи электронии ба ҳисоби шумо вобасташуда фиристода шуд.",
    newPassword: "Рамзи нав",
    newPasswordPlaceholder: "Рамзи нави худро ворид кунед",
    confirmPassword: "Такрори рамз",
    confirmPasswordPlaceholder: "Рамзро такрор кунед",
    savePassword: "Захира кардани рамз",
    saving: "Захира карда истодаем...",
    passwordRulesTitle: "Талабот ба рамз",
    passwordRuleLength: "Ҳадди ақал 8 аломат",
    passwordRuleLetter: "Ақаллан як ҳарф",
    passwordRuleNumber: "Ақаллан як рақам",
    successTitle: "Рамз бомуваффақият иваз карда шуд",
    successText: "Акнун шумо метавонед бо рамзи нави худ ба низом ворид шавед.",
    goToLogin: "Ба воридшавӣ гузаштан",
    genericError: "Амалиёт иҷро карда нашуд. Лутфан дубора кӯшиш кунед.",
    invalidOtp: "Рамзи воридшуда нодуруст аст.",
    expiredOtp: "Муҳлати рамз ба анҷом расидааст.",
    passwordMismatch: "Рамзҳо мувофиқат намекунанд.",
    required: "Ҳамаи майдонҳоро пур кунед.",
    passwordExpired: "Муҳлати рамз ба анҷом расидааст. Лутфан онро иваз кунед.",
    locked: "Ҳисоби корбар муваққатан баста шудааст.",
  },
  ru: {
    system: "Низоми ягона",
    systemSubtitle: "Единая государственная платформа цифровизации здравоохранения",
    service: "Хадамоти назорати давлатии тандурустӣ ва ҳифзи иҷтимоии аҳолӣ",
    loginTitle: "Вход в систему",
    loginSubtitle: "Введите данные для продолжения работы",
    username: "Логин",
    usernamePlaceholder: "Введите логин",
    password: "Пароль",
    passwordPlaceholder: "Введите пароль",
    showPassword: "Показать пароль",
    hidePassword: "Скрыть пароль",
    forgotPassword: "Забыли пароль?",
    login: "Войти",
    loggingIn: "Вход...",
    otpTitle: "Подтверждение входа",
    otpText: "Код подтверждения отправлен на электронную почту, привязанную к вашей учетной записи.",
    otpPlaceholder: "Введите 6-значный код",
    verify: "Подтвердить",
    verifying: "Проверка...",
    resend: "Отправить код повторно",
    resendIn: "Повторная отправка через",
    seconds: "с",
    back: "Назад",
    resetTitle: "Восстановление пароля",
    resetSubtitle: "Введите логин. Мы отправим код восстановления на электронную почту, привязанную к учетной записи.",
    sendCode: "Получить код",
    sending: "Отправка...",
    resetOtpTitle: "Код восстановления",
    resetOtpText: "Код восстановления отправлен на электронную почту, привязанную к вашей учетной записи.",
    newPassword: "Новый пароль",
    newPasswordPlaceholder: "Введите новый пароль",
    confirmPassword: "Подтверждение пароля",
    confirmPasswordPlaceholder: "Повторите пароль",
    savePassword: "Сохранить пароль",
    saving: "Сохранение...",
    passwordRulesTitle: "Требования к паролю",
    passwordRuleLength: "Минимум 8 символов",
    passwordRuleLetter: "Хотя бы одна буква",
    passwordRuleNumber: "Хотя бы одна цифра",
    successTitle: "Пароль успешно изменён",
    successText: "Теперь вы можете войти в систему с новым паролем.",
    goToLogin: "Перейти ко входу",
    genericError: "Не удалось выполнить операцию. Попробуйте ещё раз.",
    invalidOtp: "Введён неверный код.",
    expiredOtp: "Срок действия кода истёк.",
    passwordMismatch: "Пароли не совпадают.",
    required: "Заполните все поля.",
    passwordExpired: "Срок действия пароля истёк. Необходимо сменить пароль.",
    locked: "Учётная запись временно заблокирована.",
  },
};

const LOGIN_RESEND_SECONDS = 60;
const RESET_RESEND_SECONDS = 60;

function normalizeError(error, tr) {
  const raw =
    error?.response?.data?.detail ||
    error?.response?.data?.error ||
    (typeof error?.response?.data === "string" ? error.response.data : "");

  if (!raw) return tr.genericError;

  const text = Array.isArray(raw) ? raw.join(" ") : String(raw);

  if (text.includes("Неверный код") || text.includes("неверный код")) return tr.invalidOtp;
  if (text.includes("Срок действия кода истек")) return tr.expiredOtp;
  if (text.includes("Пароли не совпадают")) return tr.passwordMismatch;
  if (text.includes("Заполните все поля")) return tr.required;
  if (text.includes("Срок действия пароля истек")) return tr.passwordExpired;
  if (text.includes("Учетная запись заблокирована") || text.includes("Учётная запись заблокирована")) return tr.locked;
  if (text.includes("Неверный логин или пароль")) {
    return tr === translations.tj ? "Логин ё рамз нодуруст аст." : "Неверный логин или пароль";
  }
  if (text.includes("Для пользователя не указан email")) {
    return tr === translations.tj
      ? "Барои корбар почтаи электронӣ нишон дода нашудааст."
      : "Для пользователя не указан email";
  }
  if (text.includes("Пользователь не найден")) {
    return tr === translations.tj ? "Корбар ёфт нашуд." : "Пользователь не найден";
  }

  return text;
}

function EyeIcon({ hidden }) {
  return hidden ? (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2.2 2.2 21.8 21.8" />
      <path d="M9.9 5.1A10.9 10.9 0 0 1 12 4.9c5.3 0 9.2 4.1 10 7.1a11.5 11.5 0 0 1-2.5 4.2" />
      <path d="M6.1 6.1A11.8 11.8 0 0 0 2 12c.8 3 4.7 7.1 10 7.1 1.1 0 2.1-.2 3-.5" />
      <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
      <circle cx="12" cy="12" r="2.7" />
    </svg>
  );
}

export default function Login({ onLogin }) {
  const [lang, setLangState] = useState(getLang());
  const tr = useMemo(() => translations[lang] || translations.tj, [lang]);

  const [mode, setMode] = useState("login");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loginOtp, setLoginOtp] = useState("");
  const [resetOtp, setResetOtp] = useState("");
  const [resetPassword, setResetPassword] = useState("");
  const [resetConfirmPassword, setResetConfirmPassword] = useState("");
  const [showResetPassword, setShowResetPassword] = useState(false);
  const [showResetConfirmPassword, setShowResetConfirmPassword] = useState(false);
  const [error, setError] = useState("");
  const [info, setInfo] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendSeconds, setResendSeconds] = useState(0);

  useEffect(() => {
    if (resendSeconds <= 0) return undefined;
    const timer = window.setInterval(() => {
      setResendSeconds((value) => Math.max(0, value - 1));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [resendSeconds]);

  const clearMessages = () => {
    setError("");
    setInfo("");
  };

  const switchLanguage = (nextLang) => {
    setLangState(nextLang);
    setLang(nextLang);
  };

  const resetToLogin = () => {
    setMode("login");
    setLoginOtp("");
    setResetOtp("");
    setResetPassword("");
    setResetConfirmPassword("");
    setError("");
    setInfo("");
    setResendSeconds(0);
  };

  const handleLogin = async (event) => {
    event?.preventDefault();
    if (loading) return;
    if (!username || !password) {
      setError(tr.required);
      return;
    }
    setLoading(true);
    clearMessages();
    try {
      const res = await axios.post(`${API_URL}/api/login/request-otp/`, { username, password });
      if (res.data.requires_otp) {
        setMode("loginOtp");
        setResendSeconds(LOGIN_RESEND_SECONDS);
      }
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyLoginOtp = async (event) => {
    event?.preventDefault();
    if (loading) return;
    if (!loginOtp) {
      setError(tr.required);
      return;
    }
    setLoading(true);
    clearMessages();
    try {
      const res = await axios.post(`${API_URL}/api/login/verify-otp/`, {
        username,
        code: loginOtp,
      });
      const { access, refresh } = res.data;
      localStorage.setItem("access", access);
      localStorage.setItem("refresh", refresh);
      const me = await getMe();
      localStorage.setItem("user", JSON.stringify(me.data));
      if (typeof onLogin === "function") onLogin(me.data);
      window.location.href = "/";
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const resendLoginOtp = async () => {
    if (loading || resendSeconds > 0) return;
    setLoading(true);
    clearMessages();
    try {
      await axios.post(`${API_URL}/api/login/request-otp/`, { username, password });
      setInfo(lang === "tj" ? "Рамзи нав ба почтаи электронӣ фиристода шуд." : "Новый код отправлен на электронную почту.");
      setLoginOtp("");
      setResendSeconds(LOGIN_RESEND_SECONDS);
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const handleRequestReset = async (event) => {
    event?.preventDefault();
    if (loading) return;
    if (!username) {
      setError(tr.required);
      return;
    }
    setLoading(true);
    clearMessages();
    try {
      await axios.post(`${API_URL}/api/password/reset/request/`, { username });
      setMode("resetOtp");
      setResendSeconds(RESET_RESEND_SECONDS);
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const resendResetCode = async () => {
    if (loading || resendSeconds > 0) return;
    setLoading(true);
    clearMessages();
    try {
      await axios.post(`${API_URL}/api/password/reset/request/`, { username });
      setInfo(lang === "tj" ? "Рамзи нав ба почтаи электронӣ фиристода шуд." : "Новый код восстановления отправлен на электронную почту.");
      setResetOtp("");
      setResendSeconds(RESET_RESEND_SECONDS);
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const handleConfirmReset = async (event) => {
    event?.preventDefault();
    if (loading) return;
    if (!username || !resetOtp || !resetPassword || !resetConfirmPassword) {
      setError(tr.required);
      return;
    }
    if (resetPassword !== resetConfirmPassword) {
      setError(tr.passwordMismatch);
      return;
    }
    setLoading(true);
    clearMessages();
    try {
      await axios.post(`${API_URL}/api/password/reset/confirm/`, {
        username,
        code: resetOtp,
        password: resetPassword,
      });
      setMode("success");
      setResendSeconds(0);
      setResetOtp("");
      setResetPassword("");
      setResetConfirmPassword("");
    } catch (err) {
      setError(normalizeError(err, tr));
    } finally {
      setLoading(false);
    }
  };

  const renderPasswordInput = ({ value, onChange, placeholder, visible, setVisible, autoComplete }) => (
    <div className="nizom-password-wrap">
      <input
        className="nizom-input nizom-input-password"
        type={visible ? "text" : "password"}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        autoComplete={autoComplete}
      />
      <button
        type="button"
        className="nizom-eye"
        onClick={() => setVisible((value) => !value)}
        aria-label={visible ? tr.hidePassword : tr.showPassword}
        title={visible ? tr.hidePassword : tr.showPassword}
      >
        <EyeIcon hidden={visible} />
      </button>
    </div>
  );

  const renderMessages = () => (
    <>
      {error && <div className="nizom-alert nizom-alert-error" role="alert">{error}</div>}
      {info && <div className="nizom-alert nizom-alert-info" role="status">{info}</div>}
    </>
  );

  const renderLogin = () => (
    <form onSubmit={handleLogin} className="nizom-form">
      <div className="nizom-field">
        <label htmlFor="login-username">{tr.username}</label>
        <input
          id="login-username"
          className="nizom-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder={tr.usernamePlaceholder}
          autoComplete="username"
        />
      </div>

      <div className="nizom-field">
        <label htmlFor="login-password">{tr.password}</label>
        {renderPasswordInput({
          value: password,
          onChange: setPassword,
          placeholder: tr.passwordPlaceholder,
          visible: showPassword,
          setVisible: setShowPassword,
          autoComplete: "current-password",
        })}
      </div>

      <div className="nizom-forgot-row">
        <button type="button" className="nizom-link-button" onClick={() => { clearMessages(); setMode("forgot"); }}>
          {tr.forgotPassword}
        </button>
      </div>

      {renderMessages()}

      <button type="submit" className="nizom-primary-button" disabled={loading}>
        {loading ? tr.loggingIn : tr.login}
      </button>
    </form>
  );

  const renderOtp = (reset = false) => (
    <form onSubmit={reset ? handleConfirmReset : handleVerifyLoginOtp} className="nizom-form">
      <div className="nizom-otp-icon" aria-hidden="true"><span>✉</span></div>

      <div className="nizom-otp-copy">
        <h2>{reset ? tr.resetOtpTitle : tr.otpTitle}</h2>
        <p>{reset ? tr.resetOtpText : tr.otpText}</p>
      </div>

      <div className="nizom-field">
        <label htmlFor="otp-code">{reset ? tr.resetOtpTitle : tr.otpTitle}</label>
        <input
          id="otp-code"
          className="nizom-input nizom-otp-input"
          type="password"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          value={reset ? resetOtp : loginOtp}
          onChange={(e) => {
            const value = e.target.value.replace(/\D/g, "").slice(0, 6);
            reset ? setResetOtp(value) : setLoginOtp(value);
          }}
          placeholder={tr.otpPlaceholder}
        />
      </div>

      {reset && (
        <>
          <div className="nizom-field">
            <label>{tr.newPassword}</label>
            {renderPasswordInput({
              value: resetPassword,
              onChange: setResetPassword,
              placeholder: tr.newPasswordPlaceholder,
              visible: showResetPassword,
              setVisible: setShowResetPassword,
              autoComplete: "new-password",
            })}
          </div>

          <div className="nizom-field">
            <label>{tr.confirmPassword}</label>
            {renderPasswordInput({
              value: resetConfirmPassword,
              onChange: setResetConfirmPassword,
              placeholder: tr.confirmPasswordPlaceholder,
              visible: showResetConfirmPassword,
              setVisible: setShowResetConfirmPassword,
              autoComplete: "new-password",
            })}
          </div>

          <div className="nizom-password-rules">
            <div className="nizom-password-rules-title">{tr.passwordRulesTitle}</div>
            <div>{tr.passwordRuleLength}</div>
            <div>{tr.passwordRuleLetter}</div>
            <div>{tr.passwordRuleNumber}</div>
          </div>
        </>
      )}

      {renderMessages()}

      <button type="submit" className="nizom-primary-button" disabled={loading}>
        {loading ? (reset ? tr.saving : tr.verifying) : (reset ? tr.savePassword : tr.verify)}
      </button>

      <div className="nizom-otp-actions">
        {resendSeconds > 0 ? (
          <span className="nizom-resend-timer">{tr.resendIn} {resendSeconds} {tr.seconds}</span>
        ) : (
          <button type="button" className="nizom-link-button" onClick={reset ? resendResetCode : resendLoginOtp} disabled={loading}>
            {tr.resend}
          </button>
        )}
        <button type="button" className="nizom-secondary-link" onClick={resetToLogin}>{tr.back}</button>
      </div>
    </form>
  );

  const renderForgot = () => (
    <form onSubmit={handleRequestReset} className="nizom-form">
      <div className="nizom-step-icon" aria-hidden="true"><span>?</span></div>

      <div className="nizom-otp-copy">
        <h2>{tr.resetTitle}</h2>
        <p>{tr.resetSubtitle}</p>
      </div>

      <div className="nizom-field">
        <label htmlFor="reset-username">{tr.username}</label>
        <input
          id="reset-username"
          className="nizom-input"
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder={tr.usernamePlaceholder}
          autoComplete="username"
        />
      </div>

      {renderMessages()}

      <button type="submit" className="nizom-primary-button" disabled={loading}>
        {loading ? tr.sending : tr.sendCode}
      </button>

      <button type="button" className="nizom-secondary-link" onClick={resetToLogin}>{tr.back}</button>
    </form>
  );

  const renderSuccess = () => (
    <div className="nizom-success">
      <div className="nizom-success-icon" aria-hidden="true">✓</div>
      <h2>{tr.successTitle}</h2>
      <p>{tr.successText}</p>
      <button type="button" className="nizom-primary-button" onClick={resetToLogin}>{tr.goToLogin}</button>
    </div>
  );

  const getTitle = () => {
    switch (mode) {
      case "loginOtp": return tr.otpTitle;
      case "forgot": return tr.resetTitle;
      case "resetOtp": return tr.resetOtpTitle;
      case "success": return tr.successTitle;
      default: return tr.loginTitle;
    }
  };

  return (
    <main className="nizom-auth-page">
      <div className="nizom-auth-background nizom-auth-background-one" />
      <div className="nizom-auth-background nizom-auth-background-two" />

      <section className="nizom-auth-content">
        <div className="nizom-auth-language-row">
          <div className="nizom-language-switcher" aria-label="Language">
            <button
              type="button"
              className={lang === "tj" ? "active" : ""}
              onClick={() => switchLanguage("tj")}
            >
              TJ
            </button>
            <button
              type="button"
              className={lang === "ru" ? "active" : ""}
              onClick={() => switchLanguage("ru")}
            >
              RU
            </button>
          </div>
        </div>
        <div className="nizom-auth-branding">
          <div className="nizom-auth-brand-name">{tr.system}</div>
          <div className="nizom-auth-brand-subtitle">{tr.systemSubtitle}</div>
        </div>

        <div className="nizom-auth-card">
          <div className="nizom-auth-card-header">
            <h1>{getTitle()}</h1>
            {mode === "login" && <p>{tr.loginSubtitle}</p>}
          </div>

          {mode === "login" && renderLogin()}
          {mode === "loginOtp" && renderOtp(false)}
          {mode === "forgot" && renderForgot()}
          {mode === "resetOtp" && renderOtp(true)}
          {mode === "success" && renderSuccess()}
        </div>

        <footer className="nizom-auth-footer">
          <span>{tr.service}</span>
          <span>© {new Date().getFullYear()}</span>
        </footer>
      </section>
    </main>
  );
}
